import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { InfoIcon } from '@cognite/cogs-icons';
import { IconWrapper, getThemeClassNames } from '@cognite/cogs-utils';
import { Tooltip } from '../../tooltip/tooltip.js';

var TextLabel = function TextLabel(_a) {
  var children = _a.children,
    className = _a.className,
    info = _a.info,
    inverted = _a.inverted,
    required = _a.required,
    text = _a.text,
    asLegend = _a.asLegend,
    themeProps = _a.themeProps,
    rest = __rest(_a, ["children", "className", "info", "inverted", "required", "text", "asLegend", "themeProps"]);
  var content = jsxs(Fragment, {
    children: [children, text, required && jsx("div", {
      className: classNames('cogs-v10', 'cogs-textlabel--required'),
      children: "*"
    }), info && jsx("span", {
      className: classNames('cogs-v10', 'cogs-textlabel--info'),
      children: jsx(Tooltip, {
        content: info,
        children: jsx(IconWrapper, {
          size: 12,
          children: jsx(InfoIcon, {
            className: "cogs-v10 cogs-textlabel--icon",
            role: "tooltip",
            tabIndex: 0
          })
        })
      })
    })]
  });
  if (asLegend) {
    return jsx("legend", Object.assign({
      className: classNames('cogs-v10', 'cogs-textlabel', getThemeClassNames(inverted, themeProps), className)
    }, rest, {
      children: content
    }));
  }
  return jsx("label", Object.assign({
    className: classNames('cogs-v10', 'cogs-textlabel', getThemeClassNames(inverted, themeProps), className)
  }, rest, {
    children: content
  }));
};

export { TextLabel };
